import styled, { keyframes } from 'styled-components';

import { media } from 'utils/detection';
import Img from 'components/Img';

const displayImage = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

export default styled(Img)`
  display: none;

  ${media.medium`
    display: block;
    position: absolute;
    margin-left: -10vw;
    margin-top: -5vw;
    width: 13vw;
    height: 15vw;
    animation: 1.5s ${displayImage} 1;
 `}
`;
